<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'flight-warnings-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': !loaded }"
      @click.stop>
      <h3 class="text-center">
        Warnings for the flight <template v-if="flightData">{{ flightData.departure_airport_iata }} - {{ flightData.arrival_airport_iata }}</template>
      </h3>

      <div class="warnings-list">
        <d-alert
          v-if="!orderedWarnings.length"
          theme="warning"
          class="text-center"
          show>
          There are no warnings for the selected flight
        </d-alert>

        <div
          v-for="(warning, index) of orderedWarnings"
          :key="'warning-item-' + index"
          class="d-flex warnings-list-item">
          <div
            class="align-middle text-center warning-icon"
            :title="warning.reference_name">
            <i
              :class="'material-icons text-' + (warning.severity_level === 'HIGH' ? 'danger' : (warning.severity_level === 'MEDIUM' ? 'warning' : 'secondary'))"
              @click="$bus.$emit('show-warning-popup', 'edit', false, false, warning.id)"
              style="cursor: pointer">
              {{ getIcon(warning.reference_type) }}
            </i>
          </div>
          <div class="align-middle">
            <small>
              {{ warning.valid_from | displayFormattedDate }} - {{ warning.valid_to | filterValidTo | displayFormattedDate }}
            </small>

            <div class="align-middle warning-desc">
              <small class="text-intro">
                <strong
                  :class="'text-' + (warning.severity_level === 'HIGH' ? 'danger' : (warning.severity_level === 'MEDIUM' ? 'warning' : 'secondary'))"
                  @click="$bus.$emit('show-warning-popup', 'edit', false, false, warning.id)"
                  style="cursor: pointer">
                  {{ warning.reference_name }}
                </strong><br>
                {{ warning.message }}
              </small>
            </div>
          </div>
          <div class="align-middle warning-state ml-auto">
            <d-button
              v-if="!warning.confirmed_at && !warning.not_set_as_ack"
              theme="primary"
              size="sm"
              :disabled="!!stateChangeInProgress"
              @click="setAsACK(warning.id, index)">
              ACK
            </d-button>
          </div>
        </div>
      </div>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Close
          </d-button>

          <d-button
            @click.prevent="showWarningsView"
            outline
            theme="danger"
            class="ml-3">
            Edit
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import DateUtils from './../../utils/DateUtils';
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'FlightWarningsPopup',
  filters: {
    filterValidTo (validToDate) {
      if (validToDate === null) {
        return 'not specified';
      }

      return validToDate;
    },
    displayFormattedDate (value) {
      if (value && value !== 'not specified') {
        let input = new Date(value);
        let hourValue = value.split(' ')[1];
        hourValue = hourValue.split(':');
        let hour = [hourValue[0], hourValue[1]].join('');

        return [
          input.getDate(),
          DateUtils.getMonthShortName(input.getMonth() + 1),
          input.getFullYear().toString().substr(2, 2)
        ].map(n => n < 10 ? '0' + n : n).join('') + ' ' + hour;
      }

      return '';
    }
  },
  data () {
    return {
      isVisible: false,
      loaded: false,
      flightData: null,
      warnings: [],
      loadError: false,
      stateChangeInProgress: false
    };
  },
  computed: {
    orderedWarnings () {
      return this.warnings.slice().sort((itemA, itemB) => itemA.ordering - itemB.ordering);
    }
  },
  mounted () {
    this.$bus.$on('show-flight-warnings-popup', this.show);
    this.$bus.$on('reload-flight-warnings-in-popup', this.reload);
  },
  methods: {
    show (flightData) {
      this.flightData = flightData;
      this.isVisible = true;
      this.loaded = false;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/calendar/flights/' + this.flightData.id + '/warnings',
        outputKey: 'warnings',
        loadedKey: 'loaded',
        errorKey: 'loadError'
      });
    },
    reload () {
      this.loaded = false;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/calendar/flights/' + this.flightData.id + '/warnings',
        outputKey: 'warnings',
        loadedKey: 'loaded',
        errorKey: 'loadError'
      });
    },
    cancel () {
      this.flightData = null;
      this.isVisible = false;
      this.loaded = false;
      this.$bus.$emit('calendar-flights-update');
    },
    hide () {
      this.flightData = null;
      this.isVisible = false;
      this.loaded = false;
      this.$bus.$emit('calendar-flights-update');
    },
    getIcon (type) {
      switch (type) {
        case 'AIRCRAFT': return 'local_airport';
        case 'AIRPORT': return 'flight_takeoff';
        case 'COUNTRY': return 'language';
        case 'CREW': return 'face';
        case 'CUSTOMER': return 'work';
        case 'HOTEL': return 'local_hotel';
        case 'PASSENGER': return 'airline_seat_recline_normal';
        default: return 'warning';
      }
    },
    setAsACK (warningID, index) {
      this.stateChangeInProgress = warningID;

      FormUtils.submitInBackground({
        $http: this.$http,
        formData: {
          warning_id: warningID
        },
        endpoint: '/calendar/flights/' + this.flightData.id + '/warnings/confirm',
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during ACK operation. Please try again',
        successAction: (response) => {
          if (response.success) {
            this.warnings[index].not_set_as_ack = true;
          }

          this.stateChangeInProgress = false;
        },
        failAction: () => {
          this.stateChangeInProgress = false;
        }
      });
    },
    showWarningsView () {
      this.cancel();
      this.$router.push('/dashboard/warnings');
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-flight-warnings-popup', this.show);
    this.$bus.$off('reload-flight-warnings-in-popup', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.flight-warnings-popup {
  width: 640px;
}

.warnings-list {
  max-height: 360px;
  margin: 30px 0;
  overflow: auto;

  &-item {
    border: 1px solid #ddd;
    margin-top: 20px;
    padding: 10px 20px;

    &:first-child {
      margin-top: 0;
    }

    .warning-icon {
      align-items: center;
      display: flex;
      padding-right: 15px;
    }

    .warning-state {
      align-items: center;
      display: flex;
      padding-left: 15px;
      width: 100px;
    }
  }
}
</style>
